<template>
    <div>
        <b-modal
            id="undoCheckInModal"
            ref="undoCheckInModal"
            :lazy="true"
            title-tag="h2"
            title="Undo Check In"
        >
            <p class="mt-2 mb-2">
                Undoing check in will permanently delete any records associated
                with this appointment.
            </p>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.undoCheckInModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="save(id)" v-else variant="primary"
                        >Undo Check In</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import CensusMixin from "@/mixins/census";

export default {
    mixins: [CensusMixin],
    props: {
        instanceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            appointmentStart: null,
            loading: false
        };
    },
    methods: {
        open(id, startTime) {
            let self = this;
            self.$refs.undoCheckInModal.show();
            self.appointmentStart = startTime;
            this.id = id;
        },
        save(id) {
            let self = this;
            this.loading = true;
            this.$http
                .get(
                    process.env.APPS +
                        "index.php/schedule/appointment/undo_checkin?id=" +
                        id
                )
                .then(function (response) {
                    self.$refs.undoCheckInModal.hide();
                    self.$parent.refetch();
                    if (response.data.state == 0) {
                        self.$socket.client.emit("v-broadcast", {
                            params: response.data.response,
                            action: "refresh-treatment",
                            businessId: self._setting.business_id
                        });
                        self._message(response.data.message);

                        // Emit socket to refresh census
                        const payload = {
                            appointmentDate: self.appointmentStart.unix(),
                            appointmentId: self.id ?? null,
                            instanceId: self.instanceId
                        };

                        self.refreshCensus(payload);
                    } else {
                        self._message(response.data.message, "danger");
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
